let _global;
if (typeof window !== 'undefined') {
    // Для браузерной среды
    _global = window;
}
else if (typeof global !== 'undefined') {
    // Для среды Node.js
    _global = global;
}
else {
    throw new Error('No global object found');
}
_global.isNullOrUndefined = function (value) {
    if (typeof value === 'undefined' || value === null) {
        return true;
    }
    else {
        return false;
    }
};
_global.isValidValue = function (value) {
    if (isNullOrUndefined(value) || (typeof value === 'number' && isNaN(value))) {
        return false;
    }
    else {
        return true;
    }
};
_global.isValidString = function (value) {
    return typeof value === 'string' && !value.isEmpty();
};
_global.isValidNumber = function (value) {
    if (typeof value !== 'number' || isNaN(value)) {
        return false;
    }
    else {
        return true;
    }
};
_global.isValidArray = function (value) {
    if (typeof value === 'undefined' || value === null || value.length === 0) {
        return false;
    }
    else {
        return true;
    }
};
_global.isValidURL = function (value) {
    let url;
    try {
        url = new URL(value); // Works in both browser and Node.js (using the WHATWG URL API).
    }
    catch (_) {
        return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
};
_global.openWindow = function (url) {
    if (typeof window !== 'undefined') {
        window.open(url, '_blank');
    }
};
_global.tryParseJson = function (value) {
    try {
        return JSON.parse(value);
    }
    catch (_a) {
        return null;
    }
};
_global.setHtmlAttribute = function (attribute, value) {
    if (typeof document !== 'undefined') {
        document.documentElement.setAttribute(attribute, value);
    }
};
_global.removeHtmlAttribute = function (attribute) {
    if (typeof document !== 'undefined') {
        document.documentElement.removeAttribute(attribute);
    }
};
_global.windowHeight = function () {
    if (typeof window !== 'undefined') {
        return window.innerHeight;
    }
    else {
        return 0;
    }
};
_global.windowWidth = function () {
    if (typeof window !== 'undefined') {
        return window.innerWidth;
    }
    else {
        return 0;
    }
};
_global.getCSSVariableValue = function (name) {
    if (isNullOrUndefined(document)) {
        return '';
    }
    const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!isValidString(value)) {
        return '';
    }
    return value;
};
_global.processNaN = function (value, defaultValue) {
    if (!isValidNumber(value)) {
        return defaultValue;
    }
    return value;
};
String.prototype.startsWith =
    String.prototype.startsWith ||
        function (searchString, position) {
            return this.substr(position || 0, searchString.length) === searchString;
        };
String.prototype.endsWith =
    String.prototype.endsWith ||
        function (searchString, this_len) {
            if (this_len === undefined || this_len > this.length) {
                this_len = this.length;
            }
            return this.substring(this_len - searchString.length, this_len) === searchString;
        };
String.prototype.isEmpty = function () {
    if (isNullOrUndefined(this) || this.trim() === '') {
        return true;
    }
    return false;
};
String.CompareOrdinal =
    String.CompareOrdinal ||
        function (str1, str2) {
            if (str1 === str2) {
                return 0;
            }
            return str1 > str2 ? 1 : -1;
        };
String.StringJoin =
    String.StringJoin ||
        function (separator, strArr) {
            let res = strArr[0];
            for (let i = 1, len = strArr.length; i < len; i++) {
                res += separator + strArr[i];
            }
            return res;
        };
_global.arraysIntersection = function (a, b) {
    let t;
    // indexOf to loop over shorter
    if (b.length > a.length) {
        t = b;
        b = a;
        a = t;
    }
    return a.filter(function (e) {
        return b.includes(e);
    });
};
Object.getKeyByValue =
    Object.getKeyByValue ||
        function (obj, val) {
            for (const key in obj) {
                if (obj[key] === val) {
                    return key;
                }
            }
            return null;
        };
Array.prototype.Contains =
    Array.prototype.Contains ||
        function (obj) {
            return this.indexOf(obj) !== -1;
        };
// Date
Date.prototype.isSameDay = function (otherDate) {
    return (this.getDate() === otherDate.getDate() &&
        this.getMonth() === otherDate.getMonth() &&
        this.getFullYear() === otherDate.getFullYear());
};
if (typeof DOMRect !== 'undefined') {
    DOMRect.prototype.contains = function (x, y) {
        return this.x <= x && this.x + this.width >= x && this.y <= y && this.y + this.height >= y;
    };
}
export {};
